import React from 'react';
import { Building2, CircleDot, Flag, Plus, Store } from 'lucide-react';
import './customFieldTable.css';

const customFields = [
  {
    id: 'department',
    label: 'Department',
    fieldLabel: 'Department - Finance',
    fieldType: 'Custom',
    required: false,
    fieldAccess: 'Select access',
    hideFor: [],
    dependsOn: '',
    options: ['Payroll', 'Recruitment', 'Hardware'],
  },
  {
    id: 'priorities',
    label: 'Priorities',
    fieldLabel: 'Priorities',
    fieldType: 'Custom',
    required: false,
    fieldAccess: 'Select access',
    hideFor: [],
    dependsOn: '',
    options: ['Low', 'Medium', 'High'],
  },
  {
    id: 'statuses',
    label: 'Statuses',
    fieldLabel: 'Statuses',
    fieldType: 'Custom',
    required: false,
    fieldAccess: 'Select access',
    hideFor: [],
    dependsOn: '',
    options: ['Open', 'In Progress', 'Closed'],
  },
  {
    id: 'storeId',
    label: 'Store ID',
    fieldLabel: 'Store ID',
    fieldType: 'Custom',
    required: false,
    fieldAccess: 'Select access',
    hideFor: [],
    dependsOn: '',
    options: ['Store 101', 'Store 102', 'Store 103'],
  },
];

const fieldIcons = {
  department: Building2,
  priorities: Flag,
  statuses: CircleDot,
  storeId: Store,
};

export default function CustomFieldTable({ onAddField }) {
  return (
    <aside className="custom-field-table" aria-labelledby="custom-field-table-title">
      <h2 id="custom-field-table-title" className="custom-field-table__title">
        Custom Fields
      </h2>
      <p className="custom-field-table__description">
        Use these fields to show options from database table.
      </p>

      <div className="custom-field-table__list">
        {customFields.map((field) => {
          const FieldIcon = fieldIcons[field.id];
          return (
            <div className="custom-field-table__row" key={field.id}>
              <FieldIcon className="custom-field-table__field-icon" size={14} strokeWidth={1.5} aria-hidden="true" />
              <span className="custom-field-table__label">{field.label}</span>
              <button
                className="custom-field-table__add"
                type="button"
                aria-label={`Add ${field.label}`}
                title={`Add ${field.label}`}
                onClick={() => onAddField?.(field)}
              >
                <Plus size={14} strokeWidth={2} aria-hidden="true" />
              </button>
            </div>
          );
        })}
      </div>
    </aside>
  );
}